module.exports = __webpack_public_path__ + "static/img/msg_tab4.79a4932c.png";